// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2noaY","clinicsSelect":"TableHeading_clinicsSelect__2x4OT"};